import React from "react";
import type { ClaimStatuses } from "../../../types/travelClaims";

import UnreadMessages from "../../../assets/chat_messages.svg";
import UnreadMessagesRed from "../../../assets/chat_messages_red.svg";
import UnreadMessagesBlue from "../../../assets/chat_messages_blue.svg";

type Params = {
    count: number;
    useBg?: boolean;
    height?: number;
    claimStatus: ClaimStatuses | null;
};

export const getUnreadMessages = ({
                                      count,
                                      useBg = true,
                                      height = 8,
                                      claimStatus,
                                  }: Params) => {
    let bgClass = useBg ? "bg-melon-light " : "";
    let textClass = "";
    let icon = UnreadMessages;

    const heightClass = `h-${height}`;
    const widthClass = `w-${height * 2}`;

    // новый статус синий но непрочитанные важнее красный должен перебивать синий
    if (claimStatus === "NEW") {
        bgClass = "bg-blue-200 ";
        icon = UnreadMessagesBlue;
        textClass = "text-blue-500 ";
    }

    if (count) {
        bgClass = useBg ? "bg-red-200 " : "";
        icon = UnreadMessagesRed;
        textClass = "text-red-500 ";
    }

    return (
        <div className={`flex justify-center rounded-lg text-sm ${bgClass}${textClass}${heightClass} ${widthClass}`}>
            <div className="flex flex-row justify-center items-center">
                <img className="inline-block w-5 h-5" src={icon} alt="Unread messages" />
                {count ? count : ""}
            </div>
        </div>
    );
};
